import React from 'react'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBell, faHistory, faHome, faPlusCircle, faSignOutAlt, faUserCircle, faWallet } from '@fortawesome/free-solid-svg-icons'
import '../assets/css/navbar.css'
import logo from '../assets/images/logo-t.png'
import mcard from '../assets/images/mcard.png'
import bcard from '../assets/images/bcard.png'
import AddWallet from './modals/AddWallet'


const Navbar = () => {
    const path = window.location.pathname
    return (
        <>
        <header className="navbar navbar-dark navbar-expand-lg d-none d-lg-block sticky-top bg-dark p-0 shadow">
            <Link className="navbar-brand px-3 float-left col-5 col-md-3 col-lg-2" to="/"><img src={logo} alt="Logo" style={{height: "35px"}} />Pouch</Link>
            <button className="navbar-toggler m-2 d-lg-none float-right" data-toggle="collapse" data-target="#myNavbar">
                <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse ml-2 ml-lg-0" id="myNavbar">
                <hr className="dropdown-divider d-lg-none" />
                <ul className="navbar-nav me-auto mb-0">
                    {sessionStorage.getItem('idToken') && (
                        <li className="nav-item">
                            <Link className="nav-link text-white" to="/dashboard">Dashboard</Link>
                        </li>
                    )}
                </ul>
                {!sessionStorage.getItem('idToken') ? 
                    <ul className="navbar-nav ml-auto">
                        <li className="nav-item dropdown show">
                            <Link className="nav-link dropdown-toggle mr-2" to="#" id="dropdown01" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                                <FontAwesomeIcon icon={faUserCircle} className="h3 align-middle text-white"/>
                            </Link>
                            <div className="dropdown-menu dropoff-menu" aria-labelledby="dropdown01">
                                { path === '/signup' ?
                                    <Link className="dropdown-item m-0" to="/signin">
                                        <p className="m-0 text-muted small">Already registered?</p>
                                        <p>Sign In</p>
                                    </Link> : path === '/signin' ?
                                    <Link className="dropdown-item m-0" to="/signup">
                                        <p className="m-0 text-muted small">Not registered?</p>
                                        <p>Sign Up</p>
                                    </Link>:
                                <>
                                    <Link className="dropdown-item m-0" to="/signin">
                                        <p className="m-0 text-muted small">Already registered?</p>
                                        <p>Sign In</p>
                                    </Link>
                                    <Link className="dropdown-item m-0" to="/signup">
                                        <p className="m-0 text-muted small">Not registered?</p>
                                        <p>Sign Up</p>
                                    </Link>
                                </>
                                }
                            </div>
                        </li>
                    </ul> :
                    <ul className="navbar-nav ml-auto">
                        <li className="nav-item dropdown show">
                            <Link className="nav-link dropdown-toggle mt-1" to="#" id="dropdown2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                                <FontAwesomeIcon icon={faWallet} className="h4 align-top text-secondary" /> <span className="d-lg-none">Wallet</span>
                            </Link>
                            <div className="dropdown-menu dropoff-menu" style={{minWidth : '300px'}} aria-labelledby="dropdown2">
                                <Link className="row ml-1" to="/wallet" style={{textDecoration: 'none'}}>
                                    <div className="col-3">
                                        <img src={mcard} alt="mcard" className="rounded" style={{height : '40px'}} />
                                    </div>
                                    <div className="col-7">
                                        <p className="m-0">Coinbase </p>
                                        <p className="m-0">Balance: $5,300</p>
                                    </div>
                                </Link>
                                <hr className="dropdown-divider" />
                                <Link className="row ml-1" to="/wallet" style={{textDecoration: 'none'}}>
                                    <div className="col-3">
                                        <img src={bcard} alt="mcard" className="rounded" style={{height : '40px'}} />
                                    </div>
                                    <div className="col-7">
                                        <p className="m-0">Binance </p>
                                        <p className="m-0">Balance: $2,300</p>
                                    </div>
                                </Link>
                                <hr className="dropdown-divider" />
                                <Link className="btn btn-purple mx-1 float-left" to="/wallets"><FontAwesomeIcon icon={faWallet} className="align-middle" /> All Wallets</Link>
                                <Link className="btn btn-purple mx-1 float-right" to="#" type="button" data-toggle="modal" data-target="#modalAddWallet"><FontAwesomeIcon icon={faPlusCircle} className="align-middle" /> Add Wallet</Link>
                                <br />
                                <br />
                            </div>
                        </li>
                        <li className="nav-item">
                            <Link to="/transactions" className="nav-link mt-1">
                                <FontAwesomeIcon icon={faHistory} className="h4 align-middle" /> <span className="d-lg-none">Transactions</span>
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link to="#" className="nav-link mt-1">
                            <FontAwesomeIcon icon={faBell} className="h4 align-middle" /> <span className="d-lg-none">Notifications</span>
                            </Link>
                        </li>
                        <li className="nav-item dropdown show">
                            <Link className="nav-link dropdown-toggle mr-4 mt-1" to="#" id="dropdown01" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                                <FontAwesomeIcon icon={faUserCircle} className="h4 align-middle text-secondary" />
                            </Link>
                            <div className="dropdown-menu dropoff-menu" aria-labelledby="dropdown01">
                                <Link className="dropdown-item m-0" to="#">
                                    <p className="m-0 text-muted small">Signed in as:</p>
                                    <p className="m-0 text-muted small">@user</p>
                                </Link>
                                <Link className="dropdown-item" to="/profile">Profile</Link>
                                <Link className="dropdown-item" to="/preferences">Preferences</Link>
                                <hr className="dropdown-divider" />
                                <Link className="dropdown-item" to="/signout">Sign Out</Link>
                            </div>
                        </li>
                    </ul>
                }
            </div>
        </header>
        <AddWallet />
        {
        sessionStorage.getItem('idToken') &&
            <>
            <nav className="navbar navbar-expand navbar-dark d-block bg-transparent p-0 d-lg-none" style={{marginBottom: '-30px'}}>
                <div className="d-flex justify-content-end">                
                    <Link className="nav-link ml-auto h3 text-purple" to="#" title="Notification"><FontAwesomeIcon icon={faBell} /></Link>
                    { path === '/profile' && 
                        <Link className="nav-link h3 text-purple" to="/signout" title="Sign Out"><FontAwesomeIcon icon={faSignOutAlt} /></Link>
                    }
                </div>
            </nav>
            <nav className="navbar-expand navbar-dark fixed-bottom d-lg-none px-2 bg-dark">
                <div className="d-flex justify-content-around">
                    <Link className="nav-link h3 text-purple-shade" to="/dashboard" title="Home"><FontAwesomeIcon icon={faHome} /></Link>
                    <Link className="nav-link h3 text-purple-shade" to="/wallets" title="Wallets"><FontAwesomeIcon icon={faWallet} /></Link>
                    <Link className="nav-link h3 text-purple-shade" to="/transactions" title="Wallets"><FontAwesomeIcon icon={faHistory} /></Link>
                    <Link className="nav-link h3 text-purple-shade" to="/profile" title="Profile"><FontAwesomeIcon icon={faUserCircle} /></Link>                
                </div>
            </nav>
            </>
        }
            
        </>
    )
}

export default Navbar



